module.exports = __webpack_public_path__ + "static/media/Ofelia.f77f5af4.png";